export default __webpack_public_path__ + "static/media/hallmark-orange-crown.0cf35169.svg";